import React, { useEffect, useState } from "react";

import HeaderRegistration from "../headerRegistration/HeaderRegistration";
import GoBack from "../goBack/GoBack";
import ListEventType from "../../../../components/listEventType/ListEventType";

import { Button, Stack } from "react-bootstrap";

import { associationsWS, eventTypeWS } from "../../api/registrationApi";
import { t } from "i18next";
import { isEmpty } from "../../../../utils/validation";
import ListAssociations from "../listAssociations/ListAssociations";

const Step4 = ({
  selectedEventType,
  setSelectedEventType,
  selectedAssociations,
  setSelectedAssociations,
  admin,
  nextStep,
  previousStep,
  handleRegistration,
}) => {
  const [listEventType, setListEventType] = useState([]);
  const [listAssociation, setListAssociation] = useState([]);

  useEffect(() => {
    eventTypeWS()
      .then((res) => {
        setListEventType(res);
      })
      .catch((err) => {
        console.error(err);
      });

    associationsWS()
      .then((res) => setListAssociation(res))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center w-100 container-customize-preference pt-2 pb-2 min-vh-100">
      <div className="customize-preference">
        <Stack gap={5}>
          <HeaderRegistration
            colorTitle="#4190A3"
            titleWeight="900"
            colorSubtitle="#000"
            textAlign="center"
            title={t("registration.customize_your_experience")}
            subtitle={t("registration.subtitle_customize")}
          />
          {!admin ? (
            <ListAssociations
              data={listAssociation}
              title={t("registration.you_are_volunteer")}
              titleFontWeigth={500}
              selected={selectedAssociations}
              setSelected={setSelectedAssociations}
              disabled={false}
            />
          ) : null}
          {!isEmpty(listEventType) ? (
            <ListEventType
              data={listEventType}
              title={t("registration.where_activity")}
              textColor={"#000"}
              selected={selectedEventType}
              setSelected={setSelectedEventType}
              disabled={false}
              max={6}
            />
          ) : null}

          <Button
            variant="success"
            size="md"
            className="button-registration"
            onClick={() => {
              handleRegistration();
            }}
          >
            {t("common.follow")}
          </Button>
          <GoBack color="black" previousStep={previousStep} />
        </Stack>
      </div>
    </div>
  );
};

export default Step4;
